import { Routes } from '@angular/router';

import { CurrentGameEditComponent } from './components/current-game-edit/current-game-edit.component';

export const CURRENT_ROUTES: Routes = [{
	path: 'Current', children: [{
		path: '', component: CurrentGameEditComponent
	}]
}];
